import './registerServiceWorker';
import 'element-plus/dist/index.css';

import { createApp } from 'vue';

import ElementPlus from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';

import App from './App.vue';
import router from './router';
import store from './store';

if (typeof window !== 'undefined') {
  // 处理 ResizeObserver 相关错误(这是浏览器已知的警告,不影响功能)
  const resizeObserverErrHandler = (e) => {
    const message = e?.message || e?.reason?.message || e?.error?.message;
    if (
      message &&
      (
        message.includes('ResizeObserver loop completed with undelivered notifications') ||
        message.includes('ResizeObserver loop limit exceeded')
      )
    ) {
      e.preventDefault?.();
      e.stopImmediatePropagation?.();
      return true;
    }
    return false;
  };

  // 捕获错误事件
  window.addEventListener('error', (e) => {
    if (resizeObserverErrHandler(e)) {
      return;
    }
  }, true);

  // 捕获未处理的 Promise 拒绝
  window.addEventListener('unhandledrejection', (e) => {
    if (resizeObserverErrHandler(e)) {
      return;
    }
  });

  // 捕获控制台错误(用于 webpack-dev-server overlay)
  const originalConsoleError = console.error;
  console.error = function(...args) {
    const message = args.join(' ');
    if (
      message.includes('ResizeObserver loop completed with undelivered notifications') ||
      message.includes('ResizeObserver loop limit exceeded')
    ) {
      return; // 忽略 ResizeObserver 相关错误
    }
    originalConsoleError.apply(console, args);
  };
}

const app = createApp(App);

app.use(store);
app.use(router);
app.use(ElementPlus, { locale: zhCn });

app.mount('#app');
